import { CORE_SEATS_ENTERPRISE, CORE_SEATS_PROFESSIONAL, CRM_SUITE_STARTER_BUNDLE, HUBSPOT_FREE } from 'self-service-api/constants/ApiNames';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { SMART_CRM_CARD } from '../../constants/tracking/TrackingSources';
import ProductTiles from '../merch-card/ProductTiles';
import { ProductTile } from '../merch-card/smart-crm-and-marketing-plus-tiles/ProductTile';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKeyOverrideMap = {
  [CRM_SUITE_STARTER_BUNDLE]: 'merchCards.suiteTile.starterCard',
  [HUBSPOT_FREE]: 'merchCards.suiteTile.freeCard'
};
export const SmartCrmTiles = ({
  screen,
  productsToShow
}) => {
  return /*#__PURE__*/_jsx(ProductTiles, {
    columns: productsToShow.length,
    children: productsToShow.map((product, index) => {
      const i18nKeyOverride = i18nKeyOverrideMap[product] || undefined;
      return /*#__PURE__*/_jsx(ProductTile, {
        gridItemProps: {
          gridColumnStart: index + 1,
          paddingInline: '700'
        },
        screen: screen,
        trackingSource: SMART_CRM_CARD,
        apiName: product,
        i18nKeyOverride: i18nKeyOverride,
        productNameOverride: NavItemEnum.SMART_CRM,
        skipInterstitialPage: [CORE_SEATS_PROFESSIONAL, CORE_SEATS_ENTERPRISE].includes(product),
        showIncludedSeatsDisplay: false
      }, product);
    })
  });
};
export default SmartCrmTiles;